import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/arm-neck-body-fat-calculator',
  component: () => import('../../routes/ArmNeckFatCalculator.svelte'),
  card: {
    id: 'arm-neck-body-fat-calculator',
    title: 'Arm-Neck Body Fat Calculator',
    description: 'Estimate body fat percentage using the U.S. Army arm-neck circumference method — no scale required.',
    icon: 'fitness_center',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/arm-neck-body-fat-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Arm-Neck Body Fat Calculator – U.S. Army Circumference Method',
    description: 'Free arm-neck body fat calculator using the U.S. Army circumference formula. Enter your height and body measurements to estimate body fat percentage without a scale.',
  },
};

export default meta;
